'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mapHttpOperation = require('common/utils/map-http-operation');

var _mapHttpOperation2 = _interopRequireDefault(_mapHttpOperation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _clone(data) {
    return data != void 0 ? JSON.parse(JSON.stringify(data)) : void 0;
}

exports['default'] = {
    create: function create(app) {

        return {
            user: {
                load: function load() {
                    return Promise.resolve(_clone(app.serverSideGeneratedData.users[0]));
                }
            },
            team: {
                load: function load() {
                    return Promise.resolve(_clone(app.serverSideGeneratedData.teams[0]));
                },
                update: function update(message) {
                    return (0, _mapHttpOperation2['default'])({
                        url: '/account/editTeamName',
                        method: 'POST',
                        data: {
                            team_name: message.target.name
                        }
                    });
                }
            },
            faxLines: {
                load: function load() {
                    return Promise.resolve(_clone(app.serverSideGeneratedData.faxLines));
                },
                insert: function insert(message) {
                    return (0, _mapHttpOperation2['default'])({
                        url: '/content/registerFaxLine',
                        method: 'POST',
                        data: {
                            register_fax_line: {
                                _csrf_token: message.target.csrfToken
                            },
                            fax_line_guid: message.target.guid
                        }
                    });
                },
                update: function update(message) {
                    return (0, _mapHttpOperation2['default'])({
                        url: '/home/updateFaxLinePermissions',
                        method: 'POST',
                        data: {
                            account_guids: message.target.teamMembers.map(function (tm) {
                                return tm.guid;
                            }),
                            fax_line_guid: message.target.guid
                        }
                    });
                },
                remove: function remove(message) {
                    return (0, _mapHttpOperation2['default'])({
                        url: '/content/removeFaxLine',
                        method: 'POST',
                        data: {
                            guid: message.target.guid
                        }
                    });
                }
            },
            teamMembers: {
                load: function load() {
                    // check for pagination count
                    return Promise.resolve(_clone(app.serverSideGeneratedData.teamMembers));
                },
                insert: function insert(message) {

                    var modelData = message.target.toData();

                    // update local cache
                    app.serverSideGeneratedData.teamMembers.push(modelData);

                    return (0, _mapHttpOperation2['default'])({
                        url: '/account/addTeamMember',
                        method: 'POST',
                        data: {
                            emails: [message.target.emailAddress],
                            csrf_token: message.target.csrfToken
                        },
                        transformResponse: function transformResponse(data) {

                            var result = {
                                guid: data[0].acct_guid,
                                pending: !!data[0].pending_acceptance || data[0].pending_email_confirmation
                            };

                            Object.assign(modelData, result);

                            return result;
                        }
                    });
                },
                update: function update(message) {

                    var pathname = {

                        'ma': '/account/promoteMemberToAdmin',
                        'md': '/account/promoteMemberToDeveloper',

                        'da': '/account/promoteMemberToAdmin',
                        'dm': '/account/demoteAdminToMember',

                        'am': '/account/demoteAdminToMember',
                        'ad': '/account/promoteMemberToDeveloper'

                    }[message.target.data.roleCode + message.target.roleCode];

                    app.serverSideGeneratedData.teamMembers.forEach(function (record, i) {
                        if (record.guid === message.target.data.guid) {
                            Object.assign(record, { roleCode: message.target.roleCode });
                        }
                    });

                    return (0, _mapHttpOperation2['default'])({
                        url: pathname,
                        method: 'POST',
                        data: {
                            team_member_email: message.target.emailAddress,
                            csrf_token: message.target.csrfToken
                        }
                    });
                },
                remove: function remove(message) {

                    app.serverSideGeneratedData.teamMembers.forEach(function (record, i) {
                        if (record.guid === message.target.data.guid) {
                            app.serverSideGeneratedData.teamMembers.splice(i, 1);
                        }
                    });

                    return (0, _mapHttpOperation2['default'])({
                        url: '/account/removeTeamMember',
                        method: 'POST',
                        data: {
                            team_member_email: message.target.emailAddress,
                            is_invite: message.target.pending ? 1 : void 0,
                            csrf_token: message.target.csrfToken
                        }
                    });
                }
            }
        };
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/api/endpoints.js
 ** module id = 590
 ** module chunks = 0
 **/